import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SetIsFilterNavOpenParameter } from "@toolkit/Framework/Store/Toolkit/Pages/ProductList/Handlers/setIsFilterNavOpen";
import ProductListState from "@toolkit/Framework/Store/Toolkit/Pages/ProductList/ProductListState";
import { Draft } from "immer";

const initialState: ProductListState = {
    isFilterNavOpen: false,
};

const actions = {
    "Toolkit/Pages/ProductList/SetIsFilterNavOpen": (
        draft: Draft<ProductListState>,
        action: SetIsFilterNavOpenParameter,
    ) => {
        draft.isFilterNavOpen = action.isOpen;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type ProductListActions = Parameters<typeof reducer>[1];
export default reducer;
